let counter = 0;
const uid = (p) => p + "_" + (Date.now().toString(36)) + "_" + (counter++);

export function emptyScene(w = 1200, h = 800) {
    return {viewBox: {w, h}, shapes: [], markers: []};
}
export function addRect(scene, {x, y, w, h}) {
    return {...scene, shapes: [...scene.shapes, {id: uid("s"), type: "rect", x, y, w, h}]};
}
export function addLine(scene, points) {
    return {...scene, shapes: [...scene.shapes, {id: uid("s"), type: "line", points}]};
}
export function addText(scene, {x, y, value}) {
    return {...scene, shapes: [...scene.shapes, {id: uid("s"), type: "text", x, y, value}]};
}
export function addCircle(scene, {cx, cy, r}) {
    return {...scene, shapes: [...scene.shapes, {id: uid("s"), type: "circle", cx, cy, r}]};
}
export function addMarker(scene, {turnstileId, x, y, label}) {
    return {...scene, markers: [...scene.markers, {id: uid("m"), turnstileId, x, y, label}]};
}
// Nastaví (nebo zruší předáním null) podkladovou vrstvu — data URI sanitizovaného SVG.
export function setBackground(scene, background) {
    return {...scene, background: background || undefined};
}
export function moveMarker(scene, id, x, y) {
    return {...scene, markers: scene.markers.map((m) => (m.id === id ? {...m, x, y} : m))};
}
// Upraví libovolné vlastnosti markeru (např. velikost {scale}) dle id.
export function updateMarker(scene, id, patch) {
    return {...scene, markers: scene.markers.map((m) => (m.id === id ? {...m, ...patch} : m))};
}
// Upraví libovolné vlastnosti tvaru (posun {x,y} nebo zvětšení {w,h}) dle id.
// Nezasahuje do markerů. Tvar bez shody id se vrací beze změny (stejná reference).
export function updateShape(scene, id, patch) {
    return {...scene, shapes: scene.shapes.map((s) => (s.id === id ? {...s, ...patch} : s))};
}
export function removeElement(scene, id) {
    return {
        ...scene,
        shapes: scene.shapes.filter((s) => s.id !== id),
        markers: scene.markers.filter((m) => m.id !== id),
    };
}
